import React, { useState } from 'react'
import styled from 'styled-components'
import { SwipeableListItem } from '../../../../../generic/swipe/SwipeableListAdapter'
import AcceptIcon from '../../../../../generic/icons/IconLib/CheckIcon'
import AppleIcon from '../../../../../generic/icons/IconLib/AppleIcon'
import CloseIcon from '../../../../../generic/icons/IconLib/XIcon'
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import ScalesIcon from '../../../../../generic/icons/IconLib/ScaleIcon'
import { IOrderItem } from '../../../../../modules/API/Drivers/models/kavData'
import ProductImage from '../../queries/TeudotDetails/Components/ProductImage'
import SwipeContent from '../../knisot/Components/SwipeContent'

interface ProblemProductCardProps {
  product: IOrderItem
  index: number
  onApprove: (problemID: number) => void
  onReject: (problemID: number) => void
}

const ProblemProductCard: React.FC<ProblemProductCardProps> = ({
  product,
  index,
  onApprove,
  onReject
}) => {
  const {
    ProductID,
    OrderID,
    ProductDesc,
    VarietyDesc,
    Packs,
    Weight,
    DriverStatus
  } = product
  const [isShowReject, setIsShowReject] = useState(false)
  const [isShowApprove, setIsShowApprove] = useState(false)

  const handleSwipeReject = () => {
    setIsShowReject(!isShowReject)
  }

  const handleSwipeApprove = () => {
    setIsShowApprove(!isShowApprove)
  }

  const handleApproveClick = () => {
    onApprove(OrderID)
    setIsShowApprove(false)
  }

  const handleRejectClick = () => {
    onReject(OrderID)
    setIsShowReject(false)
  }

  const handleSwipeEnd = () => {
    setIsShowApprove(false)
    setIsShowReject(false)
  }

  return (
    <SwipeableListItem
      key={`${ProductID}-${OrderID}-${index}`}
      swipeLeft={{
        content: <SwipeContent text="לא נאסף" isPrimal position="right" />,
        action: handleSwipeReject
      }}
      swipeRight={{
        content: <SwipeContent text="נאסף" position="left" />,
        action: handleSwipeApprove
      }}
      onSwipeStart={handleSwipeEnd}
      threshold={0.4}
    >
      <ClickableWrapper
        $isPrimal={false}
        onClick={handleApproveClick}
        $isShow={isShowApprove}
        aria-label="אשר פריט"
        role="button"
        tabIndex={isShowApprove ? 0 : -1}
      >
        <Icon $isPrimal={false} >
          <AcceptIcon />
        </Icon>
      </ClickableWrapper>

      <ProductItem
        $status={DriverStatus} 
      >
        <StatusBadge $status={DriverStatus} >
          {DriverStatus === 1 ? "נאסף" : "לא נאסף"}
        </StatusBadge>
        {/* <ProductImageWrapper>
          <ProductImage id={product.ProductID} />
        </ProductImageWrapper> */}
        <ProductInfo>
          <Title>
            {`${ProductDesc.trim()} ${VarietyDesc.trim()}`}
            <AppleIcon />
          </Title>
          <SubTitle>
            <Item>
              {`${Packs}`}
              <PackageIcon />
            </Item>
            <Item>
              {`${Weight}`}
              <ScalesIcon />
            </Item>
          </SubTitle>
        </ProductInfo>
      </ProductItem>

      <ClickableWrapper
        $isPrimal={true}
        onClick={handleRejectClick}
        $isShow={isShowReject}
        aria-label="דחה פריט"
        role="button"
        tabIndex={isShowReject ? 0 : -1}
      >
        <Icon $isPrimal={true} >
          <span style={{ display: 'inline-flex', cursor: 'pointer' }} onClick={() => {}}><CloseIcon /></span>
        </Icon>
      </ClickableWrapper>
    </SwipeableListItem>
  )
}

const ClickableWrapper = styled.div<{ $isShow: boolean; $isPrimal: boolean }>`
  display: ${props => (props.$isShow ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;
  width: 4em;
  min-height: 4em;
  background: ${props => (props.$isPrimal ? 'tomato' : '#80E081')};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`

const ProductItem = styled.div<{$status: number}>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1em;
  padding: 0.75em;
  border-radius: 12px;
  background: rgba(233, 240, 240, 0.1);
  transition: all 0.2s ease;
  /* background: ${props => props.$status === 1 ? '#80E081' : 'rgba(233, 240, 240, 0.1)'}; */
  border: ${props => props.$status === 0 ? 
   '1px solid rgba(41, 127, 118, 0.1)' : 
  props.$status === 1 ? '1px solid #80E081' : 
  '1px solid tomato'};

  &:hover {
    background: rgba(233, 240, 240, 0.2);
    border-color: rgba(41, 127, 118, 0.2);
  }
`

const ProductImageWrapper = styled.div`
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ProductInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`

const Title = styled.h3`
  font-size: 1em;
  font-weight: 600;
  color: #918484;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5em;
  margin: 0;
`

const SubTitle = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1em;
`

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3em;
  color: #918484;
  font-size: 0.9em;
`

const Icon = styled.div<{ $isPrimal: boolean }>`
  background: ${props => (props.$isPrimal ? 'tomato' : '#80E081')};
  color: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  font-weight: 500;
  border-radius: 1em;
  border: none;
`

const StatusBadge = styled.div<{ $status: number }>`
  position: absolute;
  /* width: 3em; */
  /* height: 3em; */
  border-radius: 10px;
  padding: 0.5em;
  top: 0.5em;
  left: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  display: ${props => props.$status !== 0 ? 'flex' : 'none'};
  background: ${props => props.$status === 1 ? '#80E081' : 'tomato'};
  color: #fff;
`

export default ProblemProductCard

